/** Last 15 chars of programme id used as community short uid. */
export function toProgrammeShortId(programId: string): string {
    if (!programId) return ''
    return programId.length >= 15 ? programId.slice(-15) : programId
}
